import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-chevron-double-up-icon',
  imports: [],
  templateUrl: './chevron-double-up-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './chevron-double-up-icon.component.scss',
})
export class ChevronDoubleUpIconComponent {}
